import React, { ReactNode, createContext, useContext } from 'react';

// * Commercial Types.
// *
// * RECRUITMENT - for recruitment
// * MANAGEMENT - for management
// *
export enum MenuType {
  RECRUITMENT = 'recruitment',
  MANAGEMENT = 'management',
  CRM = 'crm',
  FINANCIAL = 'financial',
}

export const MENU_TYPES = [
  MenuType.RECRUITMENT,
  MenuType.MANAGEMENT,
  MenuType.CRM,
  MenuType.FINANCIAL,
];

export type TMenuTypeCtx = {
  menuType: MenuType;
  isValidMenuType: boolean;
};

export const MenuTypeCtx = createContext<TMenuTypeCtx | null>(null);

export const MenuTypeCtxProvider = ({
  validMenuTypes = MENU_TYPES,
  children,
  menuType,
}: {
  validMenuTypes: MenuType[];
  menuType: MenuType;
  children: ReactNode;
}) => {
  const isValidMenuType = validMenuTypes.includes(menuType);

  return (
    <MenuTypeCtx.Provider value={{ menuType, isValidMenuType }}>
      {children}
    </MenuTypeCtx.Provider>
  );
};

export const useMenuTypeCtx = (): TMenuTypeCtx => {
  const ctx = useContext(MenuTypeCtx);

  if (!ctx) {
    throw new Error('useMenuTypeCtx must be used within a MenuTypeCtx');
  }

  return ctx;
};
